import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type Props = {};

const HomePage = (props: Props) => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4 font-poppins">
      <div className="text-center">
        <h1 className="text-3xl md:text-4xl font-bold tracking-widest mb-6">
          ICH NEXT<sup className="text-xl align-super font-normal">®</sup>
        </h1>

        <p className="text-lg md:text-xl font-light mb-8">
          “Relevant insights can only be a result of <br />
          an integrated process of AI x Human zeitgeist”
        </p>

        <p className="inline-block px-6 py-3 mb-4 border border-white rounded-full text-lg hover:bg-white hover:text-black transition">
          ichnextlabs.ai
        </p>

        <p className="text-base mt-2">Coming Soon</p>
      </div>
    </div>
  );
};

export default HomePage;
